import ConfirmationDialog from './ConfirmationDialog';
export * from './ConfirmationDialog';
export default ConfirmationDialog;